import { twMerge } from "tailwind-merge";
import { Spinner } from "../Spinner";
import type { SpinnerProps } from "../Spinner";

export type ButtonSpinnerProps = SpinnerProps;

export const ButtonSpinner = ({
  className,
  size = "sm",
  ...props
}: ButtonSpinnerProps) => {
  return (
    <Spinner {...props} className={twMerge("-ml-1", className)} size={size} />
  );
};
